function TimeoutError(this: any, message: string) {
    this.name = 'TimeoutError';
    this.message = message;
}

export const timeoutPromise = (ms: number, promise: Promise<any> | undefined) => {
    // Create a promise that rejects in <ms> milliseconds
    const timeout = new Promise((resolve, reject) => {
        const id = setTimeout(() => {
            console.log('timeout reached');
            clearTimeout(id);
            reject(new TimeoutError('Action Timed Out'));
        }, ms);
    });

    // Returns a race between our timeout and the passed in promise
    return Promise.race([
        promise,
        timeout
    ]);
};

export const sleep = async (ms, fn, ...args) => {
    const timeout = () => new Promise((resolve) => setTimeout(resolve, ms));

    await timeout();

    return fn(...args);
};

export const SERVER_TIMEOUT = 20000; // 20 seconds